import { FinancialAccount } from "@/types/types";
import { DataGrid } from "devextreme-react";
import { Column } from "devextreme-react/data-grid";
import { ColumnCellTemplateData } from "devextreme/ui/data_grid";
import { headerRenderer } from "../gifting/grid-utils";
import { formatNumber } from "devextreme/localization";
import AHECellRender from "./AHECellRender";

type Props = {
  fas: FinancialAccount[] | undefined;
};

const AHEGrid = ({ fas }: Props) => {
  const alreadyFetchedFas = new Set<string>();

  return (
    <DataGrid
      dataSource={fas ?? []}
      showBorders={true}
      showRowLines={true}
      showColumnLines={true}
      remoteOperations={false}
      className="ao-grid grow-0"
      wordWrapEnabled={true}
      keyExpr={"externalCode"}
      onCellPrepared={(e) => {
        const style = e.cellElement.style;
        if (e.rowType === "header") {
          style.backgroundColor = "var(--primary-color)";
          style.color = "white";
        }
      }}
    >
      <Column
        dataField="name"
        allowSorting={false}
        allowEditing={false}
        width={"75%"}
        alignment={"center"}
        headerCellRender={() => headerRenderer(`asset-name`, "Asset Name")}
        cellRender={(cellData: ColumnCellTemplateData<FinancialAccount>) => (
          <AHECellRender
            alreadyFetchedFas={alreadyFetchedFas}
            cellData={cellData}
            value={cellData.data?.name}
          />
        )}
      />
      <Column
        dataField="totalFixedIncome"
        allowSorting={false}
        allowEditing={false}
        width={"25%"}
        alignment={"center"}
        headerCellRender={() => headerRenderer(`total-fixed-income`, `Fixed Income`)}
        cellRender={(cellData: ColumnCellTemplateData<FinancialAccount>) => (
          <AHECellRender
            alreadyFetchedFas={alreadyFetchedFas}
            cellData={cellData}
            value={
              Number(cellData.data?.totalFixedIncomeNCash)
                ? formatNumber(Number(cellData.data?.totalFixedIncomeNCash), "$ #,##0")
                : "—"
            }
          />
        )}
      />
    </DataGrid>
  );
};

export default AHEGrid;
